import React, { Component } from "react";
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, Modal, ModalBody, DropdownItem, DropdownMenu, UncontrolledDropdown, DropdownToggle } from 'reactstrap';
import httpClient from "../../../httpClient";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faAngleDown, faAngleLeft, faAngleRight, faTimes,
} from '@fortawesome/free-solid-svg-icons'
import data from '../../data/data.json'
import { TextField, Box } from '@mui/material';
import { connect } from 'react-redux';
import { addVisa } from "../../../slices/modalSlice";
import visa from "../../../style/css/particulier/visa.css"




class AddVisaAnnounce extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announceVisaInfo: { title: "", pays: "skikda", description: "", nbrPlaces: 10 ,checkPlaces : false ,tarification : {},devise:"DZD",FormVisa:"E-visa",TypeVisa:"touristique" },
            categorie: "Voyage",
            imgUrl: [],
            alertMaxPic: false

        }
    this.toogleaddVisa = this.toogleaddVisa.bind(this)
    

    }

    postAnnounceVoyage(evt) {
        // evt.preventDefault();
        // let info = JSON.stringify(this.state.announceVisaInfo);
        evt.preventDefault();
        const info = this.state.announceVisaInfo;
        const idOwner = this.props.idOwner;
        const files = this.state.announceVisaInfo.files


        if (this.props.addPhotoVoyage == true ) this.tooglePhotos()

 
       

    } 
    toogleaddVisa = () => this.props.dispatch(addVisa())

    onInputChange(evt) {
        evt.preventDefault();

        if (evt.target.type !== "checkbox") {
            this.setState({
                announceVisaInfo: {
                    ...this.state.announceVisaInfo,
                    [evt.target.name]: evt.target.value
                }
            })
        }
        else if (evt.target.type === "checkbox") {
            const value = evt.target.checked;
            this.setState({
                announceVisaInfo: {
                    ...this.state.announceVisaInfo,
                    checkPlaces: value
                }
            })
        }
    }
    onInputChangeTarif(evt){
        evt.preventDefault();
        if (evt.target.type == "number") {
        this.setState({
            announceVisaInfo: {
              ...this.state.announceVisaInfo,
              tarification:{...this.state.announceVisaInfo.tarification, [evt.target.name]: evt.target.value }
            }
          })
        }
        else if (evt.target.type == "text"){
            this.setState({
                announceVisaInfo: {
                    ...this.state.announceVisaInfo,
                    [evt.target.name]: evt.target.value
                }
            })
        }

    }
    onChangeUpload(e) {
        if (this.state.imgUrl.length <= 4) {
          this.setState({ files: e.target.files[0] });
          e.preventDefault();
    
          const file = e.target.files[0]
    
          this.setState({
            announceVisaInfo: {
              ...this.state.announceVisaInfo,
              files: [...this.state.announceVisaInfo.files, file]
            }
          })
    
    
    
    
          const fileReader = new FileReader();
          fileReader.onload = () => {
            this.setState({ imgUrl: [...this.state.imgUrl, fileReader.result] });
          }
          fileReader.readAsDataURL(file);
        }
        else (
          this.setState({
            alertMaxPic: true
          })
        )
    
    
      }

    getData_dropDown(e, item) {
        e.preventDefault()
        this.setState({
            announceVisaInfo: {
            ...this.state.announceVisaInfo,
            [e.currentTarget.name]: item || e.currentTarget.textContent
          }
        });
      }

    render() {
        const willayapays = data.wilayas.map(function (item, i) {
            return (
              <DropdownItem name="pays" onClick={e => this.getData_dropDown(e, item.name)}> <span>{i + 1}</span> {item.name}</DropdownItem>
            )
          }, this)
        let { title,pays,description,nbrPlaces,devise ,TypeVisa,FormVisa} = this.state.announceVisaInfo

        return (
            <>
                {/* modal travel details  */}
                <Modal isOpen={this.props.addVisa} toggle={this.toogleaddVisa} className="modal-width-details-announce modal-addVoyage" size="lg">
                    <nav className="nav-windows-addanounce mb-1">
                        <button className="close-heberg" onClick={this.toogleaddVisa} >
                            <span><FontAwesomeIcon icon={faTimes} /></span>
                        </button>
                        <div className="title-announce" >
                            Nouvelle Annonce - Visa
                        </div>
                    </nav>

                    <ModalBody className="" >
                        <Container>
                            <div className="d-flex  m-5">
                                    <Form className="w-100" onChange={this.onInputChange.bind(this)} onSubmit={this.postAnnounceVoyage.bind(this)}>

                                        <Row className="second-Row">
                                            {/* <Col sm="1" id="label-title-input"><label>Titre</label></Col>
                                            <Col sm="10" className="input-width"><Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={this.state.title} required></Input></Col> */}
                                            <h5 id="label-title-input" >Titre</h5>
                                            <Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={title} required></Input>
                                        </Row>
                                        <Row className="">
                                            {/* <div className="d-flex mr-5"> */}
                                                <UncontrolledDropdown nav className="col-4 px-0 pr-2">
                                                    Pays
                                                    <DropdownToggle className="button-add-pays title-announce-input" 
                                                    onClick={e => { this.getData_dropDown.bind(this)(e) }}
                                                    >
                                                        {pays}
                                                        <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                    </DropdownToggle>
                                                    <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                        { willayapays }
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                                <UncontrolledDropdown nav className="col-4 px-0 px-1">
                                                    Form
                                                    <DropdownToggle className="button-add-pays title-announce-input" 
                                                    onClick={e => { this.getData_dropDown.bind(this)(e) }}
                                                    >
                                                        {FormVisa}
                                                        <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                    </DropdownToggle>
                                                    <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                    <DropdownItem name="FormVisa" onClick={e => this.getData_dropDown(e)}> E-Visa </DropdownItem>
                                                        <DropdownItem name="FormVisa" onClick={e => this.getData_dropDown(e)}> Visa </DropdownItem>
                                                        </DropdownMenu>
                                                </UncontrolledDropdown>
                                                <UncontrolledDropdown nav className="col-4 px-0 pl-2">
                                                    Type du visa
                                                    <DropdownToggle className="button-add-pays title-announce-input" 
                                                    onClick={e => { this.getData_dropDown.bind(this)(e) }}>
                                                        {TypeVisa}
                                                        <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                    </DropdownToggle>
                                                    <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                        <DropdownItem name="TypeVisa" onClick={e => this.getData_dropDown(e)}>touristique</DropdownItem>
                                                        <DropdownItem name="TypeVisa" onClick={e => this.getData_dropDown(e)}>Vignette</DropdownItem>
                                                        <DropdownItem name="TypeVisa" onClick={e => this.getData_dropDown(e)}>etude</DropdownItem>
                                                        <DropdownItem name="TypeVisa" onClick={e => this.getData_dropDown(e)}>Immigration</DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                                
                                            {/* </div> */}
                                        </Row> 
                                        <Row className="d-flex mt-4">
                                            <h6>Description </h6>
                                            <textarea style={{height:"100px"}} name="description" value={description} placeholder="Decriver votre annonce" required="" class="text-area-descr form-control"></textarea>
                                        </Row>
                                        <Row className="d-flex my-3 font-weight-normal">

                                            <div className="col-4  border py-2">
                                                <div className="row  mb-2">
                                                    <label className="col-6 my-auto">Durée de sejour</label>
                                                    <input type="number" min="1" defaultValue={nbrPlaces} className="col-2  my-auto p-0 input-number-spin" name="nbrPlaces" />
                                                    <p className="col-4 text-center mx-auto my-auto">jours</p>
                                                </div>
                                                <div className="row ">
                                                    <label className="col-6 my-auto">Durée de Validité</label>
                                                    <input type="number" min="1" defaultValue={nbrPlaces} className="col-2 my-auto p-0 input-number-spin" name="nbrPlaces" />
                                                    <p className="col-4 text-center mx-auto my-auto">jours</p>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-6 my-2">Entrées</div>
                                                    <div className="col-6">
                                                        <div className="form-check my-2">
                                                            <input className="form-check-input" type="radio" name="entre" id="flexRadioDefault1" checked/>
                                                            <label className="form-check-label m-0" for="flexRadioDefault1">
                                                                Unique
                                                            </label>
                                                        </div>
                                                            <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="entre" id="flexRadioDefault2" />
                                                            <label className="form-check-label " for="flexRadioDefault2">
                                                                Multiples
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row ">
                                                    <span className="col-2 my-auto">Tarif</span>
                                                    <input width={"100%"} type="number" min="1" placeholder="**** ****,00" className="col-5 mx-2 number-input-tarifVoyage" name="Single" />
                                                    <UncontrolledDropdown className="col-3 p-0" >
                                                        <DropdownToggle className="w-100 button-add-announce" onClick={e => { this.getData_dropDown.bind(this)(e) }}>
                                                            {devise}
                                                            <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                        </DropdownToggle>
                                                        <DropdownMenu style={{ width: "50%" }}>
                                                            <DropdownItem name="devise" onClick={e => { this.getData_dropDown.bind(this)(e) }}>DZD</DropdownItem>
                                                            <DropdownItem name="devise" onClick={e => { this.getData_dropDown.bind(this)(e) }}>EUR</DropdownItem>
                                                            <DropdownItem name="devise" onClick={e => { this.getData_dropDown.bind(this)(e) }}>US</DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                      
                                                </div>

                                            </div>


                                        </Row>
                                        <Row className="d-flex mt-4">
                                                <label className="my-auto mx-3">Durée moyenne de traitment</label>
                                                <input type="number" min="1" defaultValue={nbrPlaces} className="input-number-spin" name="nbrPlaces" />
                                                <p className="my-auto mx-3">jours</p>
                                        </Row>
                                        <div className="row w-100 justify-content-between buttons-details-announces mt-4">
                                            <Button className="col-4 button-add-moule bg-white color-gh retour-button"><FontAwesomeIcon id="arrow-retour" icon={faAngleLeft} />Retour</Button>
                                            <Button className="col-4 button-add-moule  suivant-button"
                                                type="submit"
                                                onMouseDown={() => {
                                                    
                                                    this.toogleaddVisa();
                                                    

                                                }}
                                            >Confirmer<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} />
                                            </Button>
                                        </div>
                                    </Form>

                            </div>

                        </Container>
                    </ModalBody>
                </Modal>
            </>

        )
    }


}



function mapStateToProps(state) {
    return {

        addVisa: state.modal.addVisa



    }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddVisaAnnounce);